import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { ToggleWrapper, SwitchInput, Slider } from './options-toggles.styled';

const getPropName = (prop) => {
  const arr = prop.split('.');
  let out = arr.length > 1 ? arr[1] : prop;
  return out;
};

export const OptionsToggle = (props) => {
  const { saveAsParam, sendControlMsg, name, state, title } = props;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const updateState = () => {
      sendControlMsg('get_state');
    };

    const onGetState = () => {
      setTimeout(() => setLoading(false), 250);
    };

    window.socket.on('settings.set', updateState);
    window.socket.on(name, updateState);
    window.socket.on('get_state', onGetState);
    return () => {
      window.socket.off('settings.set', updateState);
      window.socket.off(name, updateState);
      window.socket.off('get_state', onGetState);
    };
  }, [name]);

  let paramName = getPropName(name);
  // if (paramName === 'set_enable_receipts') {
  //   paramName = 'enable_receipts';
  // }
  const checked = state?.[paramName] ?? false;

  const setOption = (event) => {
    const val = event.target.checked;
    setLoading(true);
    if (!saveAsParam) {
      sendControlMsg(name, { enable: val });
      return;
    }
    // as param
    sendControlMsg('settings.set', { parameter: paramName, enable: val });
  };

  return (
    <ToggleWrapper $loading={loading}>
      <label>
        <SwitchInput type="checkbox" id={name} checked={checked} onChange={setOption} />
        <Slider />
        {title}
      </label>
    </ToggleWrapper>
  );
};

OptionsToggle.propTypes = {
  state: PropTypes.object,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  saveAsParam: PropTypes.bool,
  sendControlMsg: PropTypes.func.isRequired,
};
